import { observer } from 'mobx-react-lite';
import useClosable from '../hooks/useClosable';
import { ClosableOrder } from '../store/ClosableStore';
import commonStyles from "./Common.module.css";
import Modal from "./Modal";

function UnsavedChangesModal({ onNo, onYes }: IUnsavedChangesModalProps) {
    useClosable(ClosableOrder.High, onNo);

    return (
        <Modal header="There are unsaved changes." onClose={onNo}>
            Are you sure you want to Cancel?
            <div className={[commonStyles.modalControls, commonStyles.controlGroup].join(" ")}>
                <button className={commonStyles.secondaryButton} onClick={onNo}>No</button>
                <button className={commonStyles.primaryButton} onClick={onYes}>Yes</button>
            </div>
        </Modal>
    );
}

interface IUnsavedChangesModalProps {
    onNo: () => void;
    onYes: () => void;
}

export default observer(UnsavedChangesModal);